/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksListEventTypes } from "../../funcs/webhooksListEventTypes.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEventTypesRequest$inboundSchema,
};

export const tool$webhooksListEventTypes: ToolDefinition<typeof args> = {
  name: "webhooks-list-event-types",
  description: `List all available event types that can be subscribed to.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksListEventTypes(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
